import Image from "@components/common/Image";
import cx from "classnames";
import styles from "./General.module.scss";
const View = ({ className, ...props }: any) => {
  return (
    <div className={cx(className)}>
      <Image {...props} scale={0} speed={0} />
    </div>
  );
};
export default View;
